import { render, staticRenderFns } from "./PhoneValidator.vue?vue&type=template&id=5368fc4a"
import script from "./PhoneValidator.vue?vue&type=script&lang=ts"
export * from "./PhoneValidator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports